module.exports = __webpack_public_path__ + "img/gck01_trial.30f37842.jpg";